import CardLayout from '../../../../../shared/components/card/CardLayout';
import { Button } from 'react-bootstrap';
import { TextField } from '@mui/material';
import React from 'react';
import { FaXmark } from 'react-icons/fa6';

type AdditionalPopupProps = {
    isOpen: boolean;
    type: 'email' | 'price' | 'po' | null;
    email?: string | null;
    price?: number | null;
    po?: string | null;
    onChange: (value: string | number) => void;
    onClose: () => void;
    onSubmit: () => void;
};

export const FavoritesReusablePopup = ({
    isOpen,
    type,
    email,
    price,
    po,
    onChange,
    onClose,
    onSubmit,
}: AdditionalPopupProps) => {
    if (!isOpen || !type) return null;

    const isEmail = type === 'email';
    const isPrice = type === 'price';
    const isPo = type === 'po';

    return (
        <CardLayout
            style={{ minWidth: 250, top: '-16px' }}
            classCard="position-absolute z-index-1"
            classBody="d-flex align-items-center p-2"
        >
            <TextField
                variant="outlined"
                onChange={e => onChange(e.target.value)}
                size="small"
                placeholder={isEmail ? 'Enter email' : isPo ? 'Enter PO' : 'Enter price'}
                type={isEmail ? 'email' : isPo ? 'text' : 'number'}
                value={isEmail ? email : isPo ? po : price}
                InputProps={isPrice ? { inputProps: { min: 0 } } : undefined}
                onKeyPress={event => {
                    isPrice && (event?.key === '-' || event?.key === '+') && event.preventDefault();
                }}
            />

            <Button className="mx-2" onClick={onClose} variant="outline-secondary">
                {/*<img width={17} alt="Close icon" src="/icons/img_close.png" />*/}
                <FaXmark className="text-danger" size={18} />
            </Button>

            <Button variant="outline-secondary" onClick={onSubmit}>
                <img width={15} alt="Confirm icon" src="/icons/img-switch-check.png" />
            </Button>
        </CardLayout>
    );
};
